import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export function useLockDocument(isLocked) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== isLocked) {
    t0 = () => {
      if (isLocked) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "";
      }
    };
    t1 = [isLocked];
    $[0] = isLocked;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}